import React, { useState, useContext, useEffect } from 'react';
import './index.css';
import { 
    FaUser, 
    FaCalendarAlt, 
    FaPhone
} from 'react-icons/fa';
import { Form, InputGroup, Col, Row, Button, Tabs, Tab, Card, Spinner } from 'react-bootstrap';
import InputMask from 'react-input-mask'; 
import pacientesService from '../../api/pacientesService'; 
import { NotificationContext } from '../../contexts/notification-context'; 
import { useNavigate, useParams } from 'react-router-dom';

const CadastroPacientes = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { addNotification } = useContext(NotificationContext); 

    const [formData, setFormData] = useState({  
        nome: '',
        dataNascimento: '',
        telefone: '',
        responsavel: {
            nome: '',
            telefone: ''
        },
    });

    useEffect(() => {
        if (id) {
            const carregarPaciente = async () => {
                try {
                    setLoading(true);
                    const paciente = await pacientesService.obter(id); 
                    setFormData(paciente);
                  } catch (err) {
                    console.error('Erro ao carregar paciente:', err);
                    addNotification('danger', 'Erro ao carregar paciente. Por favor, tente novamente.');
                  } finally {
                    setLoading(false);
                  }
            }            
            carregarPaciente();
        }
    }, [id]);

    const [activeTab, setActiveTab] = useState('dados-paciente');

    const [errors, setErrors] = useState({
        'dados-paciente': [],
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [section, field] = name.split('.');
            setFormData(prev => ({
                ...prev,
                [section]: {
                    ...prev[section],
                    [field]: value
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };   

    const validateFields = () => {
        const newErrors = {
            'dados-paciente': [],
        };

        if (formData.nome.trim() === '') {
            newErrors['dados-paciente'].push('Nome do paciente é obrigatório.');
        }
        if (formData.dataNascimento === '') {
            newErrors['dados-paciente'].push('Data de Nascimento é obrigatória.');
        }
        if (formData.telefone.replace(/\D/g, '').length < 11) {
            newErrors['dados-paciente'].push('Telefone do paciente está incompleto.');
        }

        setErrors(newErrors);

        return newErrors['dados-paciente'].length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const isValid = validateFields();

        if (isValid) {
            setLoading(true);

            try {
                if (id) {
                    await pacientesService.atualizar(id, formData);
                    addNotification('success', 'Paciente alterado com sucesso!');
                }else {
                    await pacientesService.inserir(formData);
                    addNotification('success', 'Paciente cadastrado com sucesso!');
                    setFormData({
                        nome: '',
                        dataNascimento: '',
                        telefone: '',
                        responsavel: {
                            nome: '',
                            telefone: ''
                        },
                    });

                    setErrors({
                        'dados-paciente': [],
                    });
                }
            } catch (err) {
                console.error('Erro ao criar paciente:', err);
                addNotification('danger', `Erro ao criar paciente. ${err?.Message}`);
            } finally {
                setLoading(false);
            }
        } else {
            errors['dados-paciente'].forEach(errorMsg => {
                addNotification('danger', errorMsg);
            });
        }
    };

    return (
        <div className="cadastro-pacientes-container">
            <Card className="shadow-sm">
                <Card.Body>
                <Card.Title className="text-center mb-4">Cadastro de Pacientes</Card.Title>
                <hr></hr>
                <Form onSubmit={handleSubmit} className="cadastro-pacientes-form">
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        id="custom-tab"
                        className="mb-3"
                    >
                        <Tab eventKey="dados-paciente" title="Dados Paciente">
                            <Row>
                                <Col md={8} sm={12} className="mb-3">
                                    <Form.Group controlId="nome">
                                        <Form.Label>Nome</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text>
                                                <FaUser />
                                            </InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                name="nome"
                                                value={formData.nome}
                                                onChange={handleChange}
                                                required
                                                placeholder="Digite o nome do paciente"
                                                isInvalid={errors['dados-paciente'].includes('Nome do paciente é obrigatório.')}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Nome do paciente é obrigatório.
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>

                                <Col md={4} sm={12} className="mb-3">
                                    <Form.Group controlId="dataNascimento">
                                        <Form.Label>Data de Nascimento</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text>
                                                <FaCalendarAlt />
                                            </InputGroup.Text>
                                            <Form.Control
                                                type="date"
                                                name="dataNascimento"
                                                value={formData.dataNascimento ? new Date(formData.dataNascimento).toISOString().split('T')[0] : ''}
                                                onChange={handleChange}
                                                required
                                                isInvalid={errors['dados-paciente'].includes('Data de Nascimento é obrigatória.')}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Data de Nascimento é obrigatória.
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={4} sm={12} className="mb-3">
                                    <Form.Group controlId="telefone">
                                        <Form.Label>Telefone</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text>
                                                <FaPhone />
                                            </InputGroup.Text>
                                            <InputMask
                                                mask="(99) 99999-9999" 
                                                value={formData.telefone}
                                                onChange={(e) => handleChange({ target: { name: 'telefone', value: e.target.value } })}
                                            >
                                                {(inputProps) => (
                                                    <Form.Control
                                                        {...inputProps}
                                                        type="text"
                                                        name="telefone"
                                                        required
                                                        placeholder="Digite o telefone"
                                                        isInvalid={errors['dados-paciente'].includes('Telefone do paciente está incompleto.')}
                                                    />
                                                )}
                                            </InputMask>
                                            <Form.Control.Feedback type="invalid">
                                                Telefone do paciente está incompleto.
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Tab>

                        <Tab eventKey="dados-responsavel" title="Dados Responsável">
                            <Row>
                                <Col md={8} sm={12} className="mb-3">
                                    <Form.Group controlId="responsavel.nome">
                                        <Form.Label>Nome do Responsável</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text>
                                                <FaUser />
                                            </InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                name="responsavel.nome"
                                                value={formData.responsavel.nome}
                                                onChange={handleChange}
                                                placeholder="Digite o nome do responsável"
                                            />
                                        </InputGroup>
                                    </Form.Group>
                                </Col>

                                <Col md={4} sm={12} className="mb-3">
                                    <Form.Group controlId="responsavel.telefone">
                                        <Form.Label>Telefone do Responsável</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text>
                                                <FaPhone />
                                            </InputGroup.Text>
                                            <InputMask
                                                mask="(99) 99999-9999" 
                                                value={formData.responsavel.telefone}
                                                onChange={(e) => handleChange({ target: { name: 'responsavel.telefone', value: e.target.value } })}
                                            >
                                                {(inputProps) => (
                                                    <Form.Control
                                                        {...inputProps}
                                                        type="text"
                                                        name="responsavel.telefone"
                                                        placeholder="Digite o telefone"
                                                    />
                                                )}
                                            </InputMask>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Tab>
                    </Tabs>
                    <Row className="mt-4">
                        <Col className="text-start"> 
                            <Button
                            variant="primary"
                            type="submit"
                            disabled={loading}
                            className="me-2"
                            >
                            {loading ? (
                                <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                />
                            ) : (
                                id ? 'Alterar' : 'Cadastrar'
                            )}
                            </Button>
                            <Button variant="secondary" onClick={() => navigate('/lista-pacientes')}>
                            Voltar
                            </Button>
                        </Col>
                    </Row>
                </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default CadastroPacientes;
